<template>
    <div class="d-flex align-items-center">
        <!-- Tamaño de la imagen para Transport -->
        <!-- <div v-if="showSettingsImgAndIsSectionTransport" class="ml-3">
            <i class="fa fa-image mr-2" aria-hidden="true"></i>
            <el-select v-b-tooltip.hover title="Tamaño de la imagen" v-model="activeSection.sizeImage" name="size_image" :style="{ width: '80px' }">
                <el-option v-for="x in measuresImages" :key="x" :label="`${x} cm`" :value="x"></el-option>
            </el-select>
        </div> -->

        <!-- <div v-if="showSettingsImgAndIsSectionTransport" class="separator-item-bar"></div> -->

        <!-- Ocultar contenido -->
        <div class="d-flex align-items-center pb-3" :style="{ width: '55px' }">
            <i class="fa fa-eye pt-2 mr-2" :class="activeSection.isShowingContent ? 'text-primary' : 'text-muted'"></i>
            <b-form-checkbox class="m-0" v-b-tooltip.hover title="Visualizar el contenido de la sección en la impresión (solo se aplica a campos de texto)"
                switch size="lg" v-model="activeSection.isShowingContent" name="is_showing_Content" />                    
        </div>

        <div v-if="showOnlyIfIsBoxBasic" class="separator-item-bar"></div>
            
        <!-- Contenido editable en la impresión -->
        <div v-if="showOnlyIfIsBoxBasic" class="d-flex align-items-center pb-3" :style="{ width: '55px' }">
            <i class="fa fa-pencil pt-2 mr-2" :class="activeSection.isEditableContent ? 'text-primary' : 'text-muted'"></i>
            <b-form-checkbox class="m-0" v-b-tooltip.hover title="Permite que el contenido sea editable en la impresión (solo se aplica a campos de texto). Si no esta activo se imprime el Identificador de la sección por defecto."
                switch size="lg" v-model="activeSection.isEditableContent" name="is_editable_content" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'VisibilitySettings',
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'measuresImages'
        ]),

        showSettingsToImage() {
            if (!this.activeSection) return false
            return this.activeSection && (this.activeSection.type == 'IMAGE' || this.activeSection.type === 'IMAGE') ? true : false
        },

        showSettingsImgAndIsSectionTransport() {
            return this.showSettingsToImage && this.activeSection.code === 'TRANSPORT'
        },

        showOnlyIfIsBoxBasic() {
            return this.activeSection.code === 'CLEAR_BOX' || this.activeSection.code === 'TEXT'
        }
    }
}
</script>

<style scoped>
.separator-item-bar {
    width: 1px;
    height: 35px;
    background-color: #e0e0e0;
    margin: 0 10px;
}
</style> 